import styled from '@emotion/styled';
import React from 'react';
import { Typography } from '@mui/material';
import { hexToRGBA } from '../../../utils';
import MobileWrapper from '../shared/MobileWrapper';



const HeaderContainer = styled('div')(() => ({
  width: '100%',
  marginTop: 20,
  alignItems: 'center',
  justifyContent: 'center',
}));

const HeaderTitleLabel = styled(Typography)({
  fontSize: 15,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  textAlign: 'center',
});

const HeaderSubTitleLabel = styled(Typography)({
  fontSize: 12,
  textAlign: 'center',
  color: '#8e8e93',
  margin: '5px 10px',
});

const ContainerDiscount = styled('div')<{ color: string }>(({ color }) => ({
  borderWidth: 1,
  borderColor: color,
  borderStyle: 'solid',
  backgroundColor: hexToRGBA(color, 0.2),
  padding: 10,
  margin: 10,
  borderRadius: 4,
}));

const TitleContainer = styled(Typography)({
  fontSize: 11,
  fontWeight: 600,
  marginBottom: 2,
});

const DiscoutCard = styled('div')({
  backgroundColor: 'white',
  borderRadius: 4,
  padding: '10px 10px',
});

const TitleDiscountCard = styled(Typography)({
  fontSize: 12,
  fontWeight: 'bold',
  textTransform: 'uppercase',
});

const ValueDiscountCard = styled(Typography)({
  fontSize: 12,
  textTransform: 'uppercase',
});

const DescriptionDiscountCard = styled(Typography)({
  fontSize: 10,
  color: '#8e8e93',
  marginTop: 2,
});

const ContainerFooter = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 10,
  margin: 10,
  width: '100%',
  position: 'absolute',
  bottom: 60,
});

const DiscountDisclaimerLabel = styled(Typography)({
  fontSize: 9,
  margin: '5px 12px',
  textAlign: 'center',
});

const Button = styled('div')<{ color: string }>(({ color }) => ({
  backgroundColor: color,
  borderRadius: 8,
  padding: '8px 10px',
  width: '60%',
}));

const AvailableOfferOnMobile: React.FC<{ data: any }> = ({ data }) => {
  return (
    <MobileWrapper data={data}>
      {(chain) => (
        <>
          <HeaderContainer>
            <HeaderTitleLabel>{data?.appLabel?.discountTitleLabel || 'Ofertas disponíveis'}</HeaderTitleLabel>
            <HeaderSubTitleLabel>{data?.appLabel?.discountSubtitleLabel || 'Você poderá aplicá-las no próximo passo'}</HeaderSubTitleLabel>
          </HeaderContainer>

          <ContainerDiscount color={chain.appColor}>
            <TitleContainer>Resgates ilimitados</TitleContainer>
            <DiscoutCard>
              <TitleDiscountCard>ETANOL</TitleDiscountCard>
              <ValueDiscountCard>R$ 0,10 DE DESCONTO</ValueDiscountCard>
              <DescriptionDiscountCard>Serão debitados 10 pontos ao aplicar essa oferta</DescriptionDiscountCard>
            </DiscoutCard>
            <Typography fontSize={10} align="center" sx={{ marginTop: '5px' }}>* Valores demonstrativos *</Typography>
          </ContainerDiscount>

          <ContainerFooter>
            {
              data?.appLabel?.discountDisclaimerLabel &&
              <DiscountDisclaimerLabel>{data?.appLabel?.discountDisclaimerLabel}</DiscountDisclaimerLabel>
            }
            <Button color={chain.appColor}>
              <Typography color="white" fontSize={14} align="center">Continuar</Typography>
            </Button>
          </ContainerFooter>
        </>
      )}
    </MobileWrapper>
  );
}

export default AvailableOfferOnMobile;